/*eslint-disable*/
import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  return (
    <Flex
      zIndex='3'
      flexDirection={{ base: "column", xl: "row" }}
      alignItems={{ base: "center", xl: "start" }}
      justifyContent='space-between'
      px={{ base: "30px", md: "50px" }}
      pb='30px'>
      <Text color={textColor} textAlign={{ base: "center", xl: "start" }}>
        &copy; {new Date().getFullYear()}
        <Text as='span' fontWeight='600' ms='4px'>
          Vui Để Học — Cùng con học mỗi ngày.
        </Text>
      </Text>
    </Flex>
  );
}
